<template>
  <nav
    class="navbar navbar-expand-lg navbar-light px-2 px-lg-5 py-3 py-lg-0"
    :class="{ 'sticky-top shadow-sm': isNavbarSticky }"
  >
    <div class="container">
      <router-link
        :to="{ name: 'home' }"
        class="navbar-brand p-0 d-flex justify-content-center align-items-center"
      >
        <img
          id="logo-img"
          v-if="isNavbarSticky"
          src="../assets/img/logo/logo-primary.png"
          alt="Logo"
        />
        <img
          id="logo-img"
          v-else
          src="../assets/img/logo/logo-secondary.png"
          alt="Logo"
        />
        <h1 class="m-0">&nbsp;{{ $store.state.title }}</h1>
      </router-link>
      <button
        class="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarCollapse"
      >
        <span class="fa fa-bars"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarCollapse">
        <div class="navbar-nav ms-auto py-0">
          <template v-for="(menu, idx) in $store.state.menus" :key="idx">
            <div v-if="menu.subMenus.length" class="nav-item dropdown">
              <router-link
                :to="{ name: menu.path }"
                class="nav-link dropdown-toggle"
                :id="`navbarDropdownMenuLink_${idx}`"
                role="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                >{{ menu.title }}
              </router-link>

              <div
                class="dropdown-menu m-0"
                :aria-labelledby="`navbarDropdownMenuLink_${idx}`"
              >
                <router-link
                  v-for="(subMenu, idx_2) in menu.subMenus"
                  class="nav-item dropdown-item"
                  :key="idx_2"
                  :to="subMenu.path"
                  >{{ subMenu.title }}</router-link
                >
              </div>
            </div>
            <router-link
              v-else
              class="nav-item nav-link"
              :to="{ name: menu.path }"
              >{{ menu.title }}</router-link
            ></template
          >
        </div>
      </div>
    </div>
  </nav>
</template>
<script>
export default {
  data() {
    return {
      isNavbarSticky: false,
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  unmounted() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      this.isNavbarSticky = window.scrollY > 45;
    },
  },
};
</script>
